import { AppointmentStatus, Route, RouteParameters } from '../../../../constants'
import { Appointment } from '../../../../types'
import { hydratePathname } from '../../../../util'

const appointmentToRedirectPathname = (appointment: Appointment, allowableAppointmentStatuses: AppointmentStatus[]): string | undefined => {
  const { status: statusDetail } = appointment
  const { status } = statusDetail

  if (allowableAppointmentStatuses.includes(status)) return

  switch (true) {
    case status === AppointmentStatus.CANCELED:
      return hydratePathname(Route.APPOINTMENT_CANCELLATION, {
        [RouteParameters.COUNTRY]: appointment.country,
        [RouteParameters.APPOINTMENT_ID]: appointment.id,
      })
    case status === AppointmentStatus.RESCHEDULED:
      return hydratePathname(Route.APPOINTMENT_RESCHEDULE, {
        [RouteParameters.COUNTRY]: appointment.country,
        [RouteParameters.APPOINTMENT_ID]: appointment.id,
      })
    default:
      return
  }
}

export { appointmentToRedirectPathname }
